import { Button } from '@mui/material';
import './Login.css';

const Login = () => {
  const handleLoginClick = () => {
    window.location.href = `${process.env.REACT_APP_BACKEND_URL || "https://turing.nanonets.com"}/v1/login`;
  };

  return (
    <div className='flex items-center justify-center'>
      <Button 
        variant="contained" 
        className="!bg-nanonetsBlue !capitalize !font-medium"
        onClick={handleLoginClick}
      >
        Login
      </Button>
    </div>
  );
};

export default Login;
